// extracted by mini-css-extract-plugin
module.exports = {"match-items":"match-items","match-item":"match-item","match-label":"match-label"};